export const Pipes_List = (t: any) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },
  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  {
    Header: t("PipeCode"),
    accessor: "item_code",
  },
  {
    Header: t("Diameter"),
    accessor: "attributes_value.diameter_mm",
  },
  {
    Header: t("Installation Date"),
    accessor: "installation_date",
  },
];
